import { defineMessages } from 'react-intl';

export default defineMessages({
	internet_connectivity_title: {
		id: 'rewards.internet_connectivity_title',
		defaultMessage: `Internet Connectivity Issue`
	},
	internet_connectivity_message: {
		id: 'rewards.internet_connectivity_message',
		defaultMessage: `It seems you have lost proper internet connectivity and we can't submit your answers.  You can hit retry below.  If this persists, please contact your rewards provider`
	},
	tuneout_title: {
		id: 'rewards.tuneout_title',
		defaultMessage: `Is this where you would tune out?`
	},
	tuneout_message: {
		id: 'rewards.tuneout_message',
		defaultMessage: `You've indicated that you've lost interest at this point. Is that true? If so, select "yes" below and we'll make note of that before you continue screening.`
	},
	rotate_device_landscape: {
		id: 'player.rotate_device_landscape',
		defaultMessage: 'Please rotate your mobile device to watch the video'
	},
	rotate_device_portrait: {
		id: 'player.rotate_device_portrait',
		defaultMessage: 'Please rotate your mobile device to complete the survey'
	},
	rotate_device_portrait_tuneout: {
		id: 'player.rotate_device_portrait_tuneout',
		defaultMessage: 'Please rotate your mobile device to answer the "tune out" question'
	}
});



// WEBPACK FOOTER //
// ./src/locales/player.js